var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",attrs:{"flex":"dir:top"}},[_c('sys-header'),_c('div',{staticClass:"autoflex",attrs:{"flex":""}},[_c('side-bar'),_c('div',{staticClass:"autoflex page-container"},[_vm._v(" article ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }